<template>
  <component :is="componentCard" class="offer-card"></component>
</template>

<script lang="ts">
import { createUseStyles } from "@fresh8/vue-jss/src";
import { defineComponent, computed } from "vue";
import { STRAPLINE, injectLayout } from "../../hooks/useLayout";
import Squarish from "./Card.vue";
import Wide from "./Wide.vue";

const useStyles = createUseStyles({
  offerWrapper: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
    position: "relative",
    flex: "1"
  }
});

export default defineComponent({
  name: "OfferWrapper",
  components: {
    Wide,
    Squarish
  },
  props: {
    marketId: { type: String, required: true },
    eventId: { type: String, required: true }
  },
  setup() {
    const classesRef = useStyles();
    const { layout } = injectLayout();

    const componentCard = computed(() => {
      switch (layout.value) {
        case STRAPLINE:
          return Wide;
        default:
          return Squarish;
      }
    });

    return {
      classes: classesRef.value,
      componentCard
    };
  }
});
</script>

<style></style>
